import React, { useState, useEffect } from "react";
import { fetchJson } from "../../lib/Fetching";
import Samples from "./Samples";
import ResultsContext, { useResultsContext } from "./contexts/ResultsContext";
import { Provider as SelectedTestsProvider } from "./contexts/SelectedTestsContext";
import { Provider as TestResultsProvider } from "./contexts/TestResultsContext";
import ErrorBoundary from "react-error-boundary";
import ErrorComponent from "./ErrorComponent";
import { useAsyncResponse } from "../common/JobStatusHooks";

function usePreventWindowUnload(preventDefault) {
  React.useEffect(
    () => {
      if (!preventDefault) return;
      const handleBeforeUnload = (event) => event.preventDefault();
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    },
    [preventDefault]
  );
}

export default function SamplesResults({
  clientView,
  initialSimpleSampleView = false,
  searchParams,
  searchCallback,
}) {
  const [simpleSampleView, setSimpleSampleView] = useState(initialSimpleSampleView);
  const [params, setParams] = useState(searchParams);
  const [asyncResponse, setAsyncResponse] = useState({});

  const { json } = useAsyncResponse({ asyncResponse, onComplete: searchCallback });
  const samples = json ? json.samples : null;
  const tests = json ? json.tests : [];
  const resultHelper = useResultsContext({ tests });
  const paramsPresent = params && Object.keys(params).length > 0;

  // Update current search params when new params passed in
  useEffect(
    () => {
      setParams(searchParams);
    },
    [searchParams]
  );

  // Run search when params changes
  useEffect(
    () => {
      search();
    },
    [params]
  );

  const toggleSimpleSampleView = () => setSimpleSampleView(!simpleSampleView);

  const search = () => {
    if (!paramsPresent) return;
    return fetchJson("/sample_testing/sample_tests/async_index.json", {
      form: { ...params },
    })
      .then((json) => setAsyncResponse(json))
      .catch((e) =>
        alert("There was an error fetching these results. Please contact i2 support.")
      );
  };

  const viewSingleSample = (sampleId) => {
    var params = {
      sample_id: sampleId,
    };
    setParams(params);
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorComponent}>
      <TestResultsProvider>
        <SelectedTestsProvider>
          <ResultsContext.Provider value={resultHelper}>
            {samples && (
              <Samples
                samples={samples}
                reloadData={search}
                clientView={clientView}
                viewSingleSample={viewSingleSample}
                simpleSampleView={simpleSampleView}
                toggleSimpleSampleView={toggleSimpleSampleView}
              />
            )}{" "}
            {paramsPresent &&
              !samples && (
                <p style={{ marginTop: 10 }}>
                  <i className="fa fa-refresh fa-spin" />
                  &nbsp; Loading...{" "}
                </p>
              )}
          </ResultsContext.Provider>
        </SelectedTestsProvider>
      </TestResultsProvider>
    </ErrorBoundary>
  );
}
